import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { bemCssModules } from '@utils';
import { useNavigate } from '@utils/hooks';

import { loginActions, useAppDispatch, userActions, useStore } from '@modules';

import Button from '@components/Button';
import QRCode from '@components/QrCode';
import CopyText from '@containers/CopyText';
import LoaderLayout from '@layouts/LoaderLayout';
import LoginLayout from '@layouts/LoginLayout';

import CopyIcon from './copy.svg';

import style from './Setup.scss';

const cn = bemCssModules(style, 'Setup');

export const Setup: CustomFC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    dispatch(userActions.getOTPSetup());
    return () => {
      dispatch(loginActions.clearProtectNext());
    };
  }, []);

  const [{ user }] = useStore();
  const { otp } = user;
  const isLoading = !!user.loaders.getOTPSetup;

  const handleShow = () => {
    setIsShow(prev => !prev);
  };

  const handleClick = () => {
    navigate(CONST.nav.verify2fa);
  };

  return (
    <LoaderLayout isLoading={isLoading}>
      <LoginLayout isHideLinks backButton={false}>
        <h1 className={cn('title')}>{t('otp.setup.header')}</h1>
        <div className={cn('block')}>
          <div className={cn('header')}>{t('otp.setup.head1')}</div>
          <div className={cn('description')}>{t('otp.setup.desc1')}</div>
        </div>
        <div className={cn('block')}>
          <div className={cn('header')}>{t('otp.setup.head2')}</div>
          <div className={cn('description')}>{t('otp.setup.desc2')}</div>
        </div>
        <div className={cn('copy-block')}>
          <div>
            {otp?.seed && (
              <CopyText className={cn('copy')} text={otp.seed} hideIcon>
                <div className={cn('copy-text')}>
                  {otp.seed}
                  <CopyIcon className={cn('copy-icon')} />
                </div>
              </CopyText>
            )}
          </div>
          {otp?.url && (
            <>
              {isShow && (
                <div>
                  <QRCode isHideLogo className={cn('qrcode')} value={otp.url} />
                </div>
              )}
              <button className={cn('link', ['link'])} onClick={handleShow}>
                {isShow ? t('otp.setup.hide') : t('otp.setup.show')}
              </button>
            </>
          )}
        </div>
        <div className={cn('block')}>
          <div className={cn('header')}>{t('otp.setup.head3')}</div>
          <div className={cn('description')}>{t('otp.setup.desc3')}</div>
        </div>
        <Button className={cn('button')} onClick={handleClick}>
          {t('otp.setup.continue')}
        </Button>
      </LoginLayout>
    </LoaderLayout>
  );
};

export default Setup;
